import { render } from "./reviews.vue?vue&type=template&id=2d14cf54&lang=html"
import script from "./reviews.vue?vue&type=script&lang=js"
export * from "./reviews.vue?vue&type=script&lang=js"

import "./reviews.vue?vue&type=style&index=0&id=2d14cf54&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__